export default __webpack_public_path__ + "static/media/db.0b57423e.svg";